import { baseApi } from "@/redux/api/baseApi";
import { tagTypes } from "@/redux/tagTypes";

export const calenderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCounselorCalender: builder.query({
      query: (counselorId: string) => ({
        url: `/public-calenders/${counselorId}`,
        method: "GET",
        // params: query,
      }),
      providesTags: [tagTypes.publicCalendar],
    }),
    getCounselorDateSlots: builder.query({
      query: ({ counselorId, date, type, service_delivery_medium, travel_minutes, timezone }) => ({
        url: `/public-calenders/${counselorId}/slots/${date}`,
        method: "GET",
        params: {
          type,
          ...(service_delivery_medium && { service_delivery_medium }),
          ...(travel_minutes != null && { travel_minutes }),
          ...(timezone && { timezone }),
        },
      }),
      providesTags: [tagTypes.publicCalendar],
    }),
    // Get practitioners available for a specific time slot (date-first flow)
    getPractitionersBySlot: builder.query({
      query: ({ date, start_time, end_time, division_id, service_id, session_type }) => ({
        url: `/public-calenders/practitioners-by-slot`,
        method: "GET",
        params: {
          date,
          start_time,
          end_time,
          division_id,
          ...(service_id && { service_id }),
          ...(session_type && { session_type }),
        },
      }),
      providesTags: [tagTypes.publicCalendar],
    }),
    // Get available dates across all practitioners (date-first flow)
    getAvailableDates: builder.query({
      query: ({ division_id, session_type, service_id, timezone }) => ({
        url: `/public-calenders/available-dates`,
        method: "GET",
        params: {
          division_id,
          ...(session_type && { session_type }),
          ...(service_id && { service_id }),
          ...(timezone && { timezone }),
        },
      }),
      providesTags: [tagTypes.publicCalendar],
    }),
    // Get time slots for a specific date across all practitioners (date-first flow)
    getSlotsByDate: builder.query({
      query: ({ date, division_id, session_type, service_id, timezone }) => ({
        url: `/public-calenders/slots-by-date`,
        method: "GET",
        params: {
          date,
          division_id,
          ...(session_type && { session_type }),
          ...(service_id && { service_id }),
          ...(timezone && { timezone }),
        },
      }),
      providesTags: [tagTypes.publicCalendar],
    }),
    // createCalenderDate: builder.mutation({
    //   query: (data) => ({
    //     url: `/calendars`,
    //     method: "POST",
    //     body: data,
    //   }),
    //   invalidatesTags: [tagTypes.calender],
    // }),
    // getSlotsByDateId: builder.query({
    //   query: ({ id, params }) => ({
    //     url: `/calendars/${id}/slots`,
    //     method: "GET",
    //     params,
    //   }),
    //   providesTags: [tagTypes.calender],
    // }),

    // createSlots: builder.mutation({
    //   query: ({ data, id }) => ({
    //     url: `/calendars/${id}/slots`,
    //     method: "POST",
    //     body: data,
    //   }),
    //   invalidatesTags: [tagTypes.calender],
    // }),
  }),
});

export const {
  useGetCounselorCalenderQuery,
  useGetCounselorDateSlotsQuery,
  useGetPractitionersBySlotQuery,
  useGetAvailableDatesQuery,
  useGetSlotsByDateQuery,
} = calenderApi;
